import { ALL_STROKE_SIDES } from '../types/movie';
export { ALL_STROKE_SIDES };
export function resolveStrokeSides(sides) {
    if (!sides)
        return { ...ALL_STROKE_SIDES };
    return {
        top: sides.top !== false,
        right: sides.right !== false,
        bottom: sides.bottom !== false,
        left: sides.left !== false,
    };
}
export function hasAnyStrokeSide(sides) {
    const resolved = resolveStrokeSides(sides);
    return resolved.top || resolved.right || resolved.bottom || resolved.left;
}
export function parseStrokeSides(raw) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw))
        return undefined;
    const record = raw;
    return resolveStrokeSides({
        top: record.top !== false,
        right: record.right !== false,
        bottom: record.bottom !== false,
        left: record.left !== false,
    });
}
/** Shape types that render as CSS boxes (per-side borders apply). */
export function supportsStrokeSides(shapeType) {
    return shapeType === 'rectangle' || shapeType === 'circle' || shapeType == null;
}
export function borderCssForSide(enabled, strokeStyle, strokeWidth, strokeColor) {
    if (!enabled || strokeStyle === 'none' || strokeWidth <= 0)
        return 'none';
    return `${strokeWidth}px ${strokeStyle ?? 'solid'} ${strokeColor}`;
}
export function buildBoxBorderStyles(obj) {
    const style = obj.strokeStyle ?? 'solid';
    const width = obj.strokeWidth ?? 2;
    const color = obj.stroke ?? '#000000';
    const sides = resolveStrokeSides(obj.strokeSides);
    if (style === 'none' || width <= 0) {
        return {
            borderTop: 'none',
            borderRight: 'none',
            borderBottom: 'none',
            borderLeft: 'none',
        };
    }
    return {
        borderTop: borderCssForSide(sides.top, style, width, color),
        borderRight: borderCssForSide(sides.right, style, width, color),
        borderBottom: borderCssForSide(sides.bottom, style, width, color),
        borderLeft: borderCssForSide(sides.left, style, width, color),
    };
}
export function toggleStrokeSide(current, side, nextEnabled) {
    return { ...resolveStrokeSides(current), [side]: nextEnabled };
}
